import React from 'react';
import { NavLink } from 'react-router-dom'; // Changed Link to NavLink
import '../App.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <NavLink to="/" className="nav-logo">
          ♻️ <span>Recycle4Life</span>
        </NavLink>
        
        <ul className="nav-menu">
          <li className="nav-item">
            <NavLink 
              to="/" 
              className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink 
              to="/allrecyclable" 
              className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")}
            >
              Recyclables
            </NavLink>
          </li>
          <li className="nav-item btn-container">
            <NavLink 
              to="/addrecyclable" 
              className={({ isActive }) => (isActive ? "nav-links-btn active-btn" : "nav-links-btn")}
            >
              Add Item
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;